
import './_vportal.js';

window.addEventListener("load", function () {
    $(".news").each(function () {
        var postsTag = "#" + $(this).attr("id");
        console.log(postsTag);
        $().vPortal({
            container: postsTag,
            el: {
                tabContainer: '.news-tabs > a',
                resultContainer: '.news-list',
                viewAll: '.viewAll',
            },
            paginationOptions: {
            }
        });

    });


});